import { useState, useRef } from "react";
import moment from "moment";
import { ITEMS_PER_PAGE } from "../../constants";

export const useTransactionHistory = (initialPosSale = []) => {
  const isFirstRender = useRef(true);
  const firstRender = isFirstRender.current;

  const initialData =
    firstRender && initialPosSale?.length
      ? initialPosSale.slice(0, ITEMS_PER_PAGE)
      : [];

  const [state, setState] = useState({
    isLoading: true,
    list: initialData,
    totalFilterCount: 0,
    totalPaidCount: 0,
    totalUnPaidCount: 0,
    totalPaid: 0,
    totalUnPaid: 0,
    totalProfit: 0,
    totalSaleAmount: 0,
  });

  const calculateItemDiscount = (item) => {
    let discount = Number(item.discount) || 0;
    let salePrice = item?.selling_price || 0;
    let discMethod = item.discount_method;
    let discountPrice = 0;

    if (discMethod == "%")
      discountPrice = (discount / 100) * salePrice * item.quantity;
    else discountPrice = discount * item.quantity;

    return discountPrice || 0;
  };

  const calculateTotals = async (data) => {
    let itemsProfit = 0;
    let itemsPaidValue = 0;
    let itemsUnPaidValue = 0;
    let totalPaidCount = 0;
    let totalUnPaidCount = 0;
    let totalSaleAmount = 0;

    await Promise.all(
      data.map(async (item) => {
        totalSaleAmount += item.amount;

        if (item.status === "paid") {
          totalPaidCount++;
          itemsPaidValue += item.amount;

          const orders = await item.orders.fetch();
          orders.forEach((orderItem) => {
            if (!orderItem.is_open_item) {
              let salePrice = orderItem.selling_price || 0;
              let costPrice = orderItem.cost_price || 0;
              let discountPrice = calculateItemDiscount(orderItem);

              itemsProfit +=
                (salePrice - costPrice) * orderItem.quantity - discountPrice;
            }
          });
        } else {
          itemsUnPaidValue += item.amount - (item?.advance_amount || 0);
          totalUnPaidCount++;
        }
      }),
    );

    return {
      totalFilteredCount: data.length,
      itemsProfit,
      itemsPaidValue,
      itemsUnPaidValue,
      totalPaidCount,
      totalUnPaidCount,
      totalSaleAmount,
    };
  };

  const handleTransaction = async ({
    business,
    filters,
    limit,
    offset,
    isCalculateTotal = true,
  }) => {
    setState((prev) => ({ ...prev, isLoading: true }));

    const start = filters?.date?.startDate
      ? moment(filters.date.startDate).startOf("day").valueOf()
      : null;

    const end = filters?.date?.endDate
      ? moment(filters.date.endDate).endOf("day").valueOf()
      : null;

    try {
      let totals = {};

      // TOTAL CALCULATION
      if (isCalculateTotal) {
        let rawData;

        if (firstRender) {
          rawData = initialPosSale;
        } else {
          const baseQuery = business.getPOSReport(start, end, filters);
          rawData = await baseQuery.fetch();
        }

        totals = await calculateTotals(rawData);
      }

      // PAGINATED LIST
      const paginatedItems = firstRender
        ? initialData
        : await business
            .getPOSReport(start, end, filters, limit, offset)
            .fetch();

      const updatedItems =
        offset > 0 ? [...state.list, ...paginatedItems] : paginatedItems;

      // flip first render
      isFirstRender.current = false;

      setState((prev) => ({
        ...prev,
        isLoading: false,
        list: updatedItems,
        ...(isCalculateTotal && {
          totalFilterCount: totals.totalFilteredCount,
          totalProfit: totals.itemsProfit,
          totalPaid: totals.itemsPaidValue,
          totalPaidCount: totals.totalPaidCount,
          totalUnPaid: totals.itemsUnPaidValue,
          totalUnPaidCount: totals.totalUnPaidCount,
          totalSaleAmount: totals.totalSaleAmount,
        }),
      }));
    } catch (error) {
      console.error(error);
      setState((prev) => ({ ...prev, isLoading: false }));
    }
  };

  return { handleTransaction, ...state };
};
